import { medconnectAgentApi } from '@/core/api/medconnect-agent';

// Export hooks for usage in components
export const {
    useSendMessageMutation,
    useGetChatHistoryQuery,
    useLazyGetChatHistoryQuery,
    useGetAllSessionsQuery,
    useGetAvailableModelsQuery,
    useGenerateExpertiseMessageMutation,
    useOcrAndAddToConsultationMutation,
    useExtractVitalSignsMutation,
} = medconnectAgentApi; 